module.exports = __webpack_public_path__ + "static/media/packWire.aaab10f2.png";